import { httpsCallable } from '@firebase/functions';
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import { firebaseFunctions } from '@rabbit/firebase/adapter-react';
import { PubSubSendEmailCommand } from '@rabbit/pubsub';
import { apiCallable } from 'libs/firebase/adapter-client-pure/src/apiCallable';
import {
  nestApiSendInviteUserEmail,
  nestApiSendResetPasswordEmail,
  nestApiSendClaimWaitingReviewEmail,
  nestApiSendNotifyRepairerEmail,
  nestApiSendChatMessageEmail,
} from '@rabbit/bizproc/core'; 
import { t } from 'i18next';
import { useContext } from 'react';
import { AppContext } from '@rabbit/app-context';

// TODO: rename all Caseflow related functions with the CF_ prefix for extra clarity, or maybe split this into separate hooks - dc
// TODO: DEV-697 - Cleanup all unused templates, both here and in mandrill
// todo: move this to a central location since it'll be used in the backend primarily in the (hopefully near) future
export const MANDRILL_TEMPLATES = {
  BLANK: 'cust_blank_template',
  WAITING_FOR_REVIEW: 'cust_waiting_for_review',
  REQUEST_SEND_ITEM: 'cust_request_send_item',
  REPLACEMENT: 'cust_replacement',
  REPAIRER_ASSIGNED: 'cust_assigned_repairer',
  QUOTE: 'cust_quote',
  CLAIM_REJECTED: 'cust_reject_close_case',
  AUTHORISED_REPAIRER_TASK_NOTIFICATION: '3rd_party_repairer_case_assigned',
  AUTHORISED_REPAIR_COMPLETE: 'cust_authorised_repair_closed',
  POST_RECEIVED: 'cust_inbound_post_received',
  GENERIC_CLOSE_CASE: 'cust_generic_close_case',
  ASSESSMENTS_DIFFER: 'cust_prelim_final_assessment_differ',
  APPROVED_FOR_REPAIR: 'cust_approved_for_repair',
  RETURN_ITEM_TO_CUST: 'cust_return_item', //TODO: not being used -VP
  REPAIR_COMPLETE: 'cust_repair_complete', //TODO: not being used -VP
  POSTAGE_LOGGED: 'cust_postage_logged',
  READY_FOR_CUST_COLLECTION: 'cust_item_ready_for_collection',
  LOCAL_REPAIRER_ASSIGNED: 'cust_local_repairer_assigned',
  PASSWORDLESS_LOGIN: 'passwordless_login',
  SAGE_RESET_PASSWORD: 'sage_reset_password',
  SAGE_INVITE_NEW_USER: 'sage_invite_new_user',
  ASSIGN_CASE: 'cust_assign_case',
  //ADD BODY TEMPLATE NAMES HERE
  BODY_BLANK: 'body_cust_blank_template',
  BODY_BLANK_V2: 'body_cust_blank_template_v2',
  BODY_AUTHORISED_REPAIRER_BLANK: 'body_authorised_repairer_blank',
  BODY_CUST_NEW_HOLDING: 'body_cust_new_holding',
  BODY_CUST_NEW_HOLDING_V2: 'body_cust_new_holding_v2',
  BODY_PASSWORDLESS_LOGIN: 'body_passwordless_login',
  BODY_PASSWORDLESS_LOGIN_V2: 'body_passwordless_login_v2',
  BODY_SAGE_RESET_PASSWORD: 'body_sage_reset_password',
  BODY_SAGE_RESET_PASSWORD_V2: 'body_sage_reset_password_v2',
  BODY_CONSUMER_CLAIM_WAITING_FOR_REVIEW:
    'body_consumer_claim_waiting_for_review',
  BODY_CONSUMER_CLAIM_WAITING_FOR_REVIEW_V2:
    'body_consumer_claim_waiting_for_review_v2',
  BODY_REQUEST_SEND_ITEM: 'body_cust_request_send_item',
  BODY_REQUEST_SEND_ITEM_V2: 'body_cust_request_send_item_v2',
  BODY_REPLACEMENT: 'body_cust_replacement',
  BODY_REPLACEMENT_V2: 'body_cust_replacement_v2',
  BODY_POSTAGE_LOGGED: 'body_cust_postage_logged',
  BODY_POSTAGE_LOGGED_V2: 'body_cust_postage_logged_v2',
  BODY_READY_FOR_CUST_COLLECTION: 'body_cust_item_ready_for_collection',
  BODY_READY_FOR_CUST_COLLECTION_V2: 'body_cust_item_ready_for_collection_v2',
  BODY_AUTHORISED_REPAIRER_TASK_NOTIFICATION:
    'body_3rd_party_repairer_case_assigned',
  BODY_AUTHORISED_REPAIRER_TASK_NOTIFICATION_V2:
    'body_3rd_party_repairer_case_assigned_v2',
  BODY_REPAIRER_ASSIGNED: 'body_cust_assigned_repairer',
  BODY_REPAIRER_ASSIGNED_V2: 'body_cust_assigned_repairer_v2',
  BODY_AUTHORISED_REPAIR_COMPLETE: 'body_cust_authorised_repair_closed',
  BODY_AUTHORISED_REPAIR_COMPLETE_V2: 'body_cust_authorised_repair_closed_v2',
  BODY_LOCAL_REPAIRER_ASSIGNED: 'body_cust_local_repairer_assigned',
  BODY_LOCAL_REPAIRER_ASSIGNED_V2: 'body_cust_local_repairer_assigned_v2',
  BODY_GENERIC_CLOSE_CASE: 'body_cust_generic_close_case',
  BODY_GENERIC_CLOSE_CASE_V2: 'body_cust_generic_close_case_v2',
  BODY_QUOTE: 'body_cust_quote',
  BODY_QUOTE_V2: 'body_cust_quote_v2',
  BODY_POST_RECEIVED: 'body_cust_inbound_post_received',
  BODY_POST_RECEIVED_V2: 'body_cust_inbound_post_received_v2',
  BODY_ASSESSMENTS_DIFFER: 'body_cust_prelim_final_assessment_differ',
  BODY_ASSESSMENTS_DIFFER_V2: 'body_cust_prelim_final_assessment_differ_v2',
  BODY_PRELIM_ASSESSMENT_V2: 'body_cust_prelim_assessment_v2',
  BODY_INITIAL_ASSESSMENT: 'body_cust_initial_assessment',
  BODY_INITIAL_ASSESSMENT_V2: 'body_cust_initial_assessment_v2',
  BODY_APPROVED_FOR_REPAIR: 'body_cust_approved_for_repair',
  BODY_APPROVED_FOR_REPAIR_V2: 'body_cust_approved_for_repair_v2',
  BODY_REPAIR_COMPLETE: 'body_cust_repair_complete',
  BODY_REPAIR_COMPLETE_V2: 'body_cust_repair_complete_v2',
  BODY_CLAIM_REJECTED: 'body_cust_reject_close_case',
  BODY_CLAIM_REJECTED_V2: 'body_cust_reject_close_case_v2',
  BODY_SAGE_INVITE_NEW_USER: 'body_sage_invite_new_user',
  BODY_SAGE_INVITE_NEW_USER_V2: 'body_sage_invite_new_user_v2',
  BODY_SAGE_VEHICLE_REGISTRATION_WIRE: 'body_sage_vehicle_registration', //only for Warranty Ireland
  // BODY_SAGE_VEHICLE_REGISTRATION_PW: 'body_sage_vehicle_registration_pw', //only for Pinnacle Warranties
  BODY_SAGE_VEHICLE_REGISTRATION_PW: 'body_sage_vehicle_registration_pw_v2', //only for Pinnacle Warranties
  BODY_SAGE_PARTNER_INVITATION: 'body_sage_partner_invitation',
  BODY_SAGE_PARTNER_INVITATION_V2: 'body_sage_partner_invitation_v2',
  BODY_SAGE_PARTNER_INVITATION_V3: 'body_sage_partner_invitation_v3',
  BODY_SAGE_STONE_REGISTRATION: 'body_sage_stone_registration',
  BODY_ASSIGN_CASE: 'body_cust_assign_case',
  BODY_ASSIGN_CASE_V2: 'body_cust_assign_case_v2',
  MAIN_HEADER_FOOTER_DEFAULT_WITHOUT_IWARRANTY_LOGO:
    'main_header_footer_default_without_iwarranty_logo',
  BODY_CHAT_MESSAGE: 'body_chat_message_template',
};

export const SHELTA_ADDRESS =
  'Unit 4/1 Foundation Place<br/>Pemulwuy NSW 2148<br/>Australia';

/** Send an e-mail through the front end. 'From' field has to include "@global.iwarranty.co"
 *  'plaintext' serves as a fallback if html is not supported. If not provided, a default message will be sent.
 *  htmlTemplate should be a stringified HTML template - likely built using MJML.
 */
export function useSendEmail() {
  const { config } = useContext(AppContext);

  const sendTemplateBodyEmailFn = FBF_CloudCallable<
    PubSubSendEmailCommand,
    any
  >('api/emails/send');

  const getTemplateFn = apiCallable(
    firebaseFunctions,
    'api/legacy/getemailtemplate'
  );

  const getResetPasswordLink = apiCallable(
    firebaseFunctions,
    'api/legacy/getresetpasswordlink'
  );

  /* -------------------------------------------------------------------------- */
  /*                               Base functions                               */
  /* -------------------------------------------------------------------------- */

  const sendEmailTemplateWithBody = async (
    emailTo: string,
    emailFrom: string,
    mergeVars: { name: string; content: string }[],
    body_template: string,
    main_template: string,
    business_name: string,
    template_language: string
  ) => {
    try {
      const res = await sendTemplateBodyEmailFn({
        to: emailTo,
        from: emailFrom,
        mergeVars,
        bodyTemplateName: body_template,
        mainTemplateName: main_template,
        businessName: business_name,
        templateLanguage: template_language,
      });

      return res;
    } catch (err) {
      throw new Error(
        `Error when sending e-mail template: ${body_template}: ${err}`
      );
    }
  };

  const getEmailTemplate = async (
    mainTemplate: string,
    bodyTemplate: string,
    mergeVars: { name: string; content: any }[]
  ) => {
    try {
      const res = await getTemplateFn({
        mainTemplate,
        bodyTemplate,
        mergeVars,
      });
      return res;
    } catch (err) {
      throw new Error(
        `Error when getting e-mail template: ${bodyTemplate}: ${err}`
      );
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                          Sage user creation invite                         */
  /* -------------------------------------------------------------------------- */

  const SE_Sage_InviteNewUser = async (
    email_to: string,
    first_name: string,
    last_name: string,
    signup_link: string,
    tenantLink: string
  ) => {
    try {
      await nestApiSendInviteUserEmail({
        emailTo: email_to,
        firstName: first_name,
        lastName: last_name,
        signupLink: signup_link,
        tenantLink: tenantLink,
      });
    } catch (err) {
      throw new Error(`Error when sending invite user email: ${err}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Template senders                              */
  /* -------------------------------------------------------------------------- */

  /* --------------------------- Caseflow Templates --------------------------- */

  /* Deprecated: moved to nest: send-passwordless-login

  const SE_Olive_Passwordless_Login = async (
    email_to: string,
    origin_link: string,
    tenantLink: string
  ) => {
    const res = await sendPasswordlessLoginEmail({
      email_to,
      email_from,
      main_template_name,
      business_name,
      origin_link,
      template_language,
    });
    if (!res) throw new Error('Error when sending passwordless login email');
      [
        {
          name: 'subject',
          content: t('email.subject.loginLink', {
            business_name: 'Warranty Login',
          }),
        },
        {
          name: 'login_link',
          content: res.data ?? res,
        },
      ],
      MANDRILL_TEMPLATES.BODY_PASSWORDLESS_LOGIN_V2,
      main_template_name,
      'Warranty Login',
      template_language
    );
    window.localStorage.setItem('emailForSignIn', email_to);
  };
  */

  const SE_Sage_ResetPassword = async (
    email_to: string,
    origin_link: string,
    tenantLink: string
  ) => {
    try {
      const res = (await getResetPasswordLink({
        email_to,
        origin_link,
      })) as unknown as { data: string };
      if (!res)
        throw new Error('Error when generating passwordless login link');
      
      await nestApiSendResetPasswordEmail({
        emailTo: email_to,
        originLink: res.data ?? res,
        tenantLink: tenantLink,
      });
      
      window.localStorage.setItem('emailForPasswordReset', email_to);
      return res;
    } catch (err) {
      throw new Error(`Error when sending password reset email: ${err}`);
    }
  };

  const SE_Olive_Claim_Waiting_For_Review = async (
    email_to: string,
    consumer_name: string,
    claim_id: string,
    product_name: string,
    case_time_created: number,
    link_to_claim: string,
    tenantLink: string
  ) => {
    try {
      await nestApiSendClaimWaitingReviewEmail({
        emailTo: email_to,
        consumerName: consumer_name,
        claimId: claim_id,
        productName: product_name,
        caseTimeCreated: case_time_created,
        linkToClaim: link_to_claim,
        tenantLink: tenantLink,
      });
      return true;
    } catch (err) {
      // Important: claim creation succeeds before this email is sent; avoid blocking the UX and causing re-submits.
      console.error('Error when sending claim waiting review email:', err);
      return false;
    }
  };

  const SE_Sage_Notify_Authorised_Repairer = async (
    email_to: string,
    claim_id: string,
    link_to_claim: string,
    first_name: string,
    product_name: string,
    tenantLink: string
  ) => {
    try {
      await nestApiSendNotifyRepairerEmail({
        emailTo: email_to,
        claimId: claim_id,
        linkToClaim: link_to_claim,
        firstName: first_name,
        productName: product_name,
        tenantLink: tenantLink,
      });
    } catch (err) {
      throw new Error(`Error when sending notify repairer email: ${err}`);
    }
  };

  const SE_Sage_Chat_Message = async (
    email_to: string,
    subject: string,
    claim_id: string,
    first_name: string,
    product_name: string,
    chat_message: string,
    link_to_claim: string,
    tenantLink: string
  ) => {
    try {
      await nestApiSendChatMessageEmail({
        emailTo: email_to,
        subject: subject,
        claimId: claim_id,
        firstName: first_name,
        productName: product_name,
        chatMessage: chat_message,
        linkToClaim: link_to_claim,
        tenantLink: tenantLink,
      });
    } catch (err) {
      throw new Error(`Error when sending chat message email: ${err}`);
    }
  };

  return {
    sendEmailTemplateWithBody,
    getEmailTemplate,
    SE_Sage_ResetPassword,
    SE_Sage_InviteNewUser,
    // SE_Olive_Passwordless_Login,
    SE_Olive_Claim_Waiting_For_Review,
    SE_Sage_Notify_Authorised_Repairer,
    SE_Sage_Chat_Message,
  };
}
